var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCongratulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5806 19V17C17.5806 16.2044 17.9099 15.4413 18.4959 14.8787C19.082 14.3161 19.8768 14 20.7056 14C21.5344 14 22.3293 14.3161 22.9153 14.8787C23.5014 15.4413 23.8306 16.2044 23.8306 17M23.8306 17V20M23.8306 17C23.8306 16.2044 24.1599 15.4413 24.7459 14.8787C25.332 14.3161 26.1268 14 26.9556 14C27.7844 14 28.5793 14.3161 29.1653 14.8787C29.7514 15.4413 30.0806 16.2044 30.0806 17V20V7C30.0806 6.20435 30.4099 5.44129 30.9959 4.87868C31.582 4.31607 32.3768 4 33.2056 4C34.0344 4 34.8293 4.31607 35.4153 4.87868C36.0014 5.44129 36.3306 6.20435 36.3306 7V28C36.3306 31.1826 35.0137 34.2348 32.6695 36.4853C30.3253 38.7357 27.1458 40 23.8306 40H19.664H20.0973C18.0272 40.0003 15.9893 39.5071 14.1668 38.5646C12.3443 37.622 10.7942 36.2597 9.65562 34.6C9.51898 34.4003 9.38287 34.2003 9.24729 34C8.59729 33.042 6.31604 29.224 2.40146 22.544C2.00239 21.8631 1.8958 21.0595 2.10434 20.3043C2.31288 19.5491 2.8201 18.9018 3.51812 18.5C4.26162 18.0717 5.13286 17.8942 5.99346 17.9957C6.85405 18.0972 7.65467 18.4718 8.26812 19.06L11.3306 22L11.3306 5C11.3306 4.20435 11.6599 3.44129 12.2459 2.87868C12.832 2.31607 13.6268 2 14.4556 2C15.2844 2 16.0793 2.31607 16.6653 2.87868C17.2514 3.44129 17.5806 4.20435 17.5806 5V20",
    stroke: "#1E5A5B",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCongratulations);
export default __webpack_public_path__ + "static/media/iconCongratulations.e376a6820ea8f2c230edf604e573b62b.svg";
export { ForwardRef as ReactComponent };